import React from 'react';
import useStore from 'state/state';
import ShareIcon from 'assets/images/icons/share.svg';
import CloseIcon from 'assets/images/icons/close.svg';
import GTMTracker from 'tracking/gtm-tracker';
import StandardButton from 'components/StandardButton/StandardButton';
import { useSpring, animated } from 'react-spring';

import styles from './Share.module.scss';

const Share = () => {
  const appData = useStore((state) => state.appData);

  const setIsShareOpen = useStore((state) => state.setIsShareOpen);
  const props = useSpring({ to: { opacity: 1 }, from: { opacity: 0 } });
  const subject = appData.mainData.shareDialog.emailSubject;

  const getShareURL = () => {
    let url = window.location.href;
    if (appData.mainData.shareDialog.shareUrl) {
      if (appData.mainData.shareDialog.shareUrl !== '') {
        url = appData.mainData.shareDialog.shareUrl;
      }
    }
    return url;
  };

  const body = `${appData.mainData.shareDialog.emailBodyText} ${getShareURL()}`;

  const close = () => {
    setIsShareOpen(false);
  };

  const copyToClipboard = () => {
    // Assuming we are hosted on HTTPS
    GTMTracker.push('Share', 'CopyUrl');
    navigator.clipboard.writeText(getShareURL());
  };

  const onFacebookShare = () => {
    GTMTracker.push('Share', 'Facebook');
    window.open(
      `https://www.facebook.com/sharer/sharer.php?u=${getShareURL()}`,
      '_blank'
    );
  };

  const onLinkedinShare = () => {
    GTMTracker.push('Share', 'LinkedIn');
    window.open(
      `https://www.linkedin.com/sharing/share-offsite/?url=${getShareURL()}`,
      '_blank'
    );
  };

  const onMailShare = () => {
    GTMTracker.push('Share', 'Email');
    window.open(`mailto:?subject=${subject}&body=${body}`, '_blank');
  };

  return (
    <animated.div style={props}>
      <div className={styles.wrapper}>
        <button
          type="button"
          className={styles.tint}
          label="tint"
          onClick={close}
        />
        <div className={styles.content}>
          <button
            label="close"
            type="button"
            onClick={close}
            className={styles.close}
          >
            <CloseIcon />
          </button>
          <div className={styles.icon}>
            <ShareIcon />
          </div>
          <p className={styles.description}>
            {appData.mainData.shareDialog.shareDescriptionText}
          </p>
          <div className={styles.buttons}>
            <StandardButton
              className={styles.button}
              icon="facebook"
              label="Facebook"
              onClick={onFacebookShare}
              iconAlignLeft
            />
            <StandardButton
              className={styles.button}
              icon="linkedin"
              label="LinkedIn"
              onClick={onLinkedinShare}
              iconAlignLeft
            />
            <StandardButton
              className={styles.button}
              onClick={onMailShare}
              icon="mail"
              label={appData.mainData.shareDialog.emailLabelText}
              iconAlignLeft
            />
            <StandardButton
              className={styles.button}
              icon="copyUrl"
              label={appData.mainData.shareDialog.copyUrlText}
              iconAlignLeft
              onClick={copyToClipboard}
            />
          </div>
        </div>
      </div>
    </animated.div>
  );
};

export default Share;
